//import React from 'react'
import { connect } from 'react-redux'
import  Filter  from '../components/Filter'
import * as actions from '../actions'
import * as filterObject from '../reducers/filter'

const mapStateToProps = (state, ownProps) => {
	return {car:ownProps.car, filter:filterObject.getFilter(state, ownProps.car)}
}

const FilterContainer = connect(
  mapStateToProps,
  {onChange: actions.setFilter}
)(Filter)

export default FilterContainer









// WEBPACK FOOTER //
// ./src/containers/FilterContainer.js